import { DOCUMENT } from '@angular/common';
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { CommonService } from './common.service';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root'
})
export class ErrorHandlingInterceptorService implements HttpInterceptor {

  constructor(
               public commonService:CommonService,
               private router :Router,
               public translateService:TranslateService,
               @Inject(DOCUMENT) private document: Document) { }
  intercept(httpRequest: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(httpRequest)
     .pipe(
       catchError((error: HttpErrorResponse) => {
          const failedUrl = error.url || httpRequest.url || '';
          const shortUrl = failedUrl.split('?')[0];
          const detail = `HTTP ${error.status || 0}: ${shortUrl}`;
          console.error('HTTP error', error.status, failedUrl, error);

          if(error.status===401)
        {
          if (shortUrl.includes('get-sas-token') || shortUrl.includes('generate-jwt')) {
            return throwError(error);
          }
          alert(`Access token has expired.\n${detail}`);
          this.commonService.removeToken();
           this.document.location.href = this.commonService.logOutUrl;
        }
        else if(error.status===500){
          alert(`An error occurred.\n${detail}`);
          // Do not hard-redirect on generate-jwt failures during local login —
          // keep the page so the developer can retry with a valid session.
          if (!shortUrl.includes('generate-jwt')) {
            this.commonService.removeToken();
            this.document.location.href = this.commonService.logOutUrl;
          }
        }
        else{
          alert(`An error occurred.\n${detail}`);
        }
        return throwError(error);
       })
     )
 }
}
